import "./LanguageSwitcher.scss";

const LanguageSwitcher = () => {
  // English-only for now. Country-based toggle disabled.
  // To re-enable later, restore useGeoCountry + languageMap + i18n toggle in this component.
  //
  // const country = useGeoCountry();
  // const defaultLanguage = languageMap[country] || "en";
  // const toggleLanguage = () => {
  //   const newLanguage = i18n.language === "en" ? defaultLanguage : "en";
  //   i18n.changeLanguage(newLanguage);
  //   localStorage.setItem("language", newLanguage);
  // };

  return (
    <button className="language-btn" type="button" disabled aria-label="English">
      English
    </button>
  );
};

export default LanguageSwitcher;
